module.exports = __webpack_public_path__ + "img/messenger.4a7229d2.svg";